import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Switch from '../../../../../core/components/switch/Switch';
import Timeline from '../../../../../core/components/timeline/Timeline';
import { useAppDispatch, useAppSelector } from '../../../../../store/hooks';
import {
  getEnquiryTimelineThunk,
  postEnquiryTimelineNoteThunk,
} from '../../../../../store/thunks/enquiry/detailsThunks';
import { enqEnquiryTimelineSelector, enqTimelineFiltersSelector } from '../../../../../store/selectors/enquiriesSelector';
import Pagination from '../../../../../core/components/pagination/Pagination';
import EnquiryEvent from './EnquiryEvent';
import { setEnqTimelineFilters } from '../../../../../store/slices/enquiriesSlice';
import usePermission from '../../../../../permissions-handling/permissionHook';
import { PermissionEnum } from '../../../../../core/enums/dictionariesEnums';
import ActivityLabel from '../../../../../common/components/activity-events/ActivityLabel';
import ActivityNoteInput from '../../../../../common/components/activity-events/ActivityNoteInput';

const ActivityComponent: React.FC = () => {
  const [value, setValue] = useState('');

  const { id } = useParams();
  const dispatch = useAppDispatch();
  const timelineFilters = useAppSelector(enqTimelineFiltersSelector);
  const { items, totalCount } = useAppSelector(enqEnquiryTimelineSelector);
  const allowedToAddNote = usePermission(PermissionEnum.EnquiryViewPage);

  const timelineList = items.map((el) => ({
    label: <ActivityLabel time={el.dateTime} initiator={el.initiator} />,
    description: <EnquiryEvent item={el} />,
  }));

  useEffect(() => {
    id && dispatch(getEnquiryTimelineThunk({
      enquiryId: +id,
      filters: timelineFilters,
    }));
    // eslint-disable-next-line
  }, [id, timelineFilters.mainOnly, timelineFilters.page]);

  const addNote = () => {
    id && dispatch(postEnquiryTimelineNoteThunk({
      enquiryId: +id, content: value.trim(), setValue: () => setValue(''),
    }));
  };
  return (
    <section className="detailsWrap__activity info-grid__column">
      <div className="info-grid__title-wrapper">
        <h2 className="info-grid__title-inner">Activity</h2>
        <Switch
          checked={!timelineFilters.mainOnly}
          onChange={(val) => dispatch(setEnqTimelineFilters({ ...timelineFilters, mainOnly: !val, page: 1 }))}
          textLeft="Main events"
          textRight="Full log"
          singleBackground
        />
      </div>
      <Pagination
        currentPage={timelineFilters.page}
        pageSize={timelineFilters.pageSize}
        onChange={(page) => {
          dispatch(setEnqTimelineFilters({ ...timelineFilters, page }));
        }}
        totalItems={totalCount}
        showSizeChanger={false}
        showTotal={false}
      />
      <Timeline timelineList={timelineList} className="detailsWrap__activity-log" />
      {/* <MentionInputWithButton */}
      <ActivityNoteInput
        value={value}
        setValue={setValue}
        addNote={addNote}
        disabledInput={!allowedToAddNote}
      />
    </section>
  );
};

export default ActivityComponent;
